import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RefreshButtonComponent } from '@gelato-api-ui/ui-kit/src/lib/components/refresh-button/refresh-button.component';
import { ReadMoreComponent } from '../../ read-more/read-more.component';

@Component({
  standalone: true,
  selector: 'ui-page-header-headless',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  imports: [CommonModule, RefreshButtonComponent, ReadMoreComponent],
})
export class PageHeaderComponent {
  @Input() text = '';
  @Input() description = '';
  @Input() isMobile = false;
  @Input() showRefreshButton = false;
  @Input() showDivider = true;
  @Input() isLoading = false;
  @Input() useH1Tag = false;
  @Output() refresh = new EventEmitter();

  onRefreshClick(): void {
    this.refresh.emit();
  }
}
